import { businessKey } from 'queryKeys';

const AUDIENCES = 'audiences';
const AUDIENCES_EXPORT = 'audienceExport';
const PARTNER = 'partner';

const MUTATION_BATCH_SYNC = 'batchSyncAudiences';
const MUTATION_BATCH_DELETE = 'batchDeleteAudiences';
const MUTATION_START_EXPORT = 'startExport';
const MUTATION_EXPORT = 'export';
const MUTATION_SYNC_PARTNER = 'syncPartner';
const MUTATION_TOGGLE = 'toggle';
const MUTATION_SYNC = 'sync';
const MUTATION_ESTIMATE = 'estimate';
const audiencesQuery = businessKey.query(AUDIENCES);

export const grid = audiencesQuery.grid();
export const chart = audiencesQuery.chart();
export const mutations = audiencesQuery.mutations();
export const details = audiencesQuery.details();
export const model = audiencesQuery.exact();
export const partnerAudiences = audiencesQuery.exact(PARTNER);

export const create = mutations.create();
export const archive = mutations.archive();
export const remove = mutations.delete();
export const restore = mutations.restore();
export const update = mutations.update();

export const batchDeleteAU = mutations.mutate(MUTATION_BATCH_DELETE);
export const batchSyncAU = mutations.mutate(MUTATION_BATCH_SYNC);
export const startExportAU = mutations.mutate(MUTATION_START_EXPORT);
export const exportAudience = businessKey
  .query(AUDIENCES_EXPORT)
  .mutations()
  .mutate(MUTATION_EXPORT);
export const sync = mutations.mutate(MUTATION_SYNC);
export const syncPartner = mutations.mutate(MUTATION_SYNC_PARTNER);
export const toggle = mutations.mutate(MUTATION_TOGGLE);
export const estimate = mutations.mutate(MUTATION_ESTIMATE);
